"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BackfillCacheProvider", {
    enumerable: true,
    get: function() {
        return BackfillCacheProvider;
    }
});
const _backfillWrapper = require("../backfillWrapper.js");
const _backfillcache = require("backfill-cache");
const _util = require("util");
const _fs = /*#__PURE__*/ _interop_require_wildcard(require("fs"));
const _path = /*#__PURE__*/ _interop_require_wildcard(require("path"));
const _getCacheDirectory = require("../getCacheDirectory.js");
const _chunkPromise = require("../chunkPromise.js");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const rm = (0, _util.promisify)(_fs.rm);
const readdir = (0, _util.promisify)(_fs.readdir);
const stat = (0, _util.promisify)(_fs.stat);
const MS_IN_A_DAY = 1000 * 60 * 60 * 24;
class BackfillCacheProvider {
    getTargetCacheStorageProvider(cwd, hash) {
        const { cacheOptions } = this.options;
        const { cacheStorageConfig, incrementalCaching } = (0, _backfillWrapper.createBackfillCacheConfig)(cwd, cacheOptions, this.backfillLogger);
        const cachePath = this.getCachePath(cwd, hash);
        return (0, _backfillcache.getCacheStorageProvider)(cacheStorageConfig ?? {
            provider: "local"
        }, cachePath, this.backfillLogger, cwd, incrementalCaching);
    }
    async fetch(hash, target) {
        const { logger } = this.options;
        if (!hash) {
            return false;
        }
        const cacheStorage = this.getTargetCacheStorageProvider(target.cwd, hash);
        try {
            return await cacheStorage.fetch(hash);
        } catch (error) {
            let message;
            if (error instanceof Error) {
                message = error.message;
            } else message = String(error);
            logger.silly(`Cache fetch failed: ${message}`, {
                target
            });
            // backfill fetch can error, but we should simply ignore and continue
            return false;
        }
    }
    async put(hash, target) {
        const { logger } = this.options;
        if (!hash) {
            return;
        }
        const cacheStorage = this.getTargetCacheStorageProvider(target.cwd, hash);
        try {
            await cacheStorage.put(hash, target.outputs ?? this.options.cacheOptions.outputGlob ?? [
                "**/*"
            ]);
        } catch (error) {
            let message;
            if (error instanceof Error) {
                message = error.message;
            } else message = String(error);
            logger.silly(`Cache fetch failed: ${message}`, {
                target
            });
        // backfill throws an error if outputGlob doesn't match any files, we will skip this error
        }
    }
    async clear(concurrency = 10) {
        return this.purge(0, concurrency);
    }
    async purge(prunePeriod = 30, concurrency = 10) {
        const now = new Date();
        const cacheTypes = [
            "cache",
            "logs"
        ];
        const entries = [];
        for (const cacheType of cacheTypes){
            const cacheTypeDirectory = _path.join((0, _getCacheDirectory.getCacheDirectoryRoot)(this.options.root), cacheType);
            if (_fs.existsSync(cacheTypeDirectory)) {
                const hashPrefixes = await readdir(cacheTypeDirectory);
                for (const prefix of hashPrefixes){
                    const cachePath = _path.join(cacheTypeDirectory, prefix);
                    entries.push(cachePath);
                }
            }
        }
        await (0, _chunkPromise.chunkPromise)(entries.map((entry)=>{
            return async ()=>{
                const entryPath = entry;
                const entryStat = await stat(entryPath);
                if (now.getTime() - entryStat.mtime.getTime() > prunePeriod * MS_IN_A_DAY) {
                    await removeCache(entryPath, entryStat);
                }
            };
        }), concurrency);
    }
    getCachePath(packagePath, hash) {
        return _path.relative(packagePath, (0, _getCacheDirectory.getCacheDirectory)(this.options.root, hash));
    }
    constructor(options){
        _define_property(this, "options", void 0);
        /**
   * logger for backfill
   */ _define_property(this, "backfillLogger", void 0);
        this.options = options;
        this.backfillLogger = (0, _backfillWrapper.createBackfillLogger)();
    }
}
async function removeCache(cachePath, entryStat) {
    if (entryStat.isDirectory()) {
        return rm(cachePath, {
            recursive: true
        });
    } else {
        return rm(cachePath);
    }
}
